import { getAnalytics } from "firebase/analytics"
import { initializeApp } from "firebase/app"
import { doc, getDoc, getFirestore, setDoc } from "firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD7q-Gf2jiiCi86Al4dzWghXDc16LJ2fcU",
  authDomain: "nhl-pickems.firebaseapp.com",
  projectId: "nhl-pickems",
  storageBucket: "nhl-pickems.appspot.com",
  messagingSenderId: "375748964679",
  appId: "1:375748964679:web:dac1605095c66243a7dc62",
  measurementId: "G-QFVZJ2SEWE",
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
export const analytics = getAnalytics(app)
export const db = getFirestore(app)

const folderName = "playoffs2023654321"
const fileName = "playerTeams"

export const save = async (data) => {
  if (!data) console.error("No data to save")
  if (window.confirm("Saving will overwrite your data, continue?")) {
    console.log("Saving ", data)
    await setDoc(doc(db, folderName, fileName), data)
      .then(() => {
        console.log("SAVED")
      })
      .catch((e) => {
        console.log("Save Error: ", e)
      })
  }
}

export const open = async () => {
  const docRef = doc(db, folderName, fileName)
  const docSnap = await getDoc(docRef)

  if (docSnap.exists()) {
    console.log("Loaded data:", docSnap.data())

    return docSnap.data()
  } else {
    // doc.data() will be undefined in this case
    console.log("No such document!")
  }
}

export const erase = () => {
  if (window.confirm("Erase DB")) save({})
}

export const getLocalStorage = () => {
  return window.localStorage.getItem("config")
}
